// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectSelectionModal_overlay__Wmcjs {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ProjectSelectionModal_fadeIn__DGHdE 0.3s ease-out;
}

.ProjectSelectionModal_overlay__Wmcjs.ProjectSelectionModal_closing__6Dor3 {
  animation: ProjectSelectionModal_fadeOut__vVRRO 0.3s ease-out;
}

.ProjectSelectionModal_modal__8M3Xx {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  animation: ProjectSelectionModal_slideIn__CzzeL 0.3s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.ProjectSelectionModal_modal__8M3Xx.ProjectSelectionModal_closing__6Dor3 {
  animation: ProjectSelectionModal_slideOut__EV9Iq 0.3s ease-out;
}

.ProjectSelectionModal_header__WOrj0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.ProjectSelectionModal_header__WOrj0 h2 {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}

.ProjectSelectionModal_closeButton__nm1iY, .ProjectSelectionModal_backButton__tQeYZ {
  background: none;
  border: none;
  color: #888;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.ProjectSelectionModal_closeButton__nm1iY:hover, .ProjectSelectionModal_backButton__tQeYZ:hover {
  color: #fff;
}

.ProjectSelectionModal_backButton__tQeYZ {
  margin-right: 10px;
}

.ProjectSelectionModal_searchContainer__9SSiL {
  position: relative;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.ProjectSelectionModal_searchInput__30qzb {
  width: 100%;
  padding: 10px 40px 10px 15px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.ProjectSelectionModal_searchInput__30qzb:focus {
  border-color: #4a9eff;
}

.ProjectSelectionModal_searchInput__30qzb::placeholder {
  color: #888;
}

.ProjectSelectionModal_content__rhOC0 {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.ProjectSelectionModal_projectItem__whlDo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 8px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ProjectSelectionModal_projectItem__whlDo:hover {
  background: rgba(74, 158, 255, 0.1);
  border-color: #4a9eff;
  transform: translateX(4px);
}

.ProjectSelectionModal_projectItem__whlDo.ProjectSelectionModal_selected__zovpN {
  background: rgba(74, 158, 255, 0.2);
  border-color: #4a9eff;
}

.ProjectSelectionModal_projectInfo__1EDR1 {
  flex: 1 1;
}

.ProjectSelectionModal_projectName__W1mpg {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.ProjectSelectionModal_clientName__Dgz\\+w {
  color: #888;
  font-size: 12px;
}

.ProjectSelectionModal_loading__WfCSt {
  text-align: center;
  padding: 40px;
  color: #888;
}

.ProjectSelectionModal_noResults__B7uzK {
  text-align: center;
  padding: 40px;
  color: #888;
  font-style: italic;
}

/* Animations */
@keyframes ProjectSelectionModal_fadeIn__DGHdE {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ProjectSelectionModal_fadeOut__vVRRO {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes ProjectSelectionModal_slideIn__CzzeL {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes ProjectSelectionModal_slideOut__EV9Iq {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
}

/* Scrollbar styling */
.ProjectSelectionModal_content__rhOC0::-webkit-scrollbar {
  width: 8px;
}

.ProjectSelectionModal_content__rhOC0::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.ProjectSelectionModal_content__rhOC0::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.ProjectSelectionModal_content__rhOC0::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectSelectionModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4DAA+B;AACjC;;AAEA;EACE,6DAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,6DAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,8DAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.overlay.closing {\r\n  animation: fadeOut 0.3s ease-out;\r\n}\r\n\r\n.modal {\r\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\r\n  animation: slideIn 0.3s ease-out;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.modal.closing {\r\n  animation: slideOut 0.3s ease-out;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.closeButton, .backButton {\r\n  background: none;\r\n  border: none;\r\n  color: #888;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.closeButton:hover, .backButton:hover {\r\n  color: #fff;\r\n}\r\n\r\n.backButton {\r\n  margin-right: 10px;\r\n}\r\n\r\n.searchContainer {\r\n  position: relative;\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.searchInput {\r\n  width: 100%;\r\n  padding: 10px 40px 10px 15px;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.searchInput:focus {\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.searchInput::placeholder {\r\n  color: #888;\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 10px;\r\n}\r\n\r\n.projectItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 15px;\r\n  margin-bottom: 8px;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.projectItem:hover {\r\n  background: rgba(74, 158, 255, 0.1);\r\n  border-color: #4a9eff;\r\n  transform: translateX(4px);\r\n}\r\n\r\n.projectItem.selected {\r\n  background: rgba(74, 158, 255, 0.2);\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.projectInfo {\r\n  flex: 1;\r\n}\r\n\r\n.projectName {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.clientName {\r\n  color: #888;\r\n  font-size: 12px;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #888;\r\n}\r\n\r\n.noResults {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n/* Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeOut {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideOut {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(20px);\r\n  }\r\n}\r\n\r\n/* Scrollbar styling */\r\n.content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.content::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.content::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.content::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ProjectSelectionModal_overlay__Wmcjs`,
	"fadeIn": `ProjectSelectionModal_fadeIn__DGHdE`,
	"closing": `ProjectSelectionModal_closing__6Dor3`,
	"fadeOut": `ProjectSelectionModal_fadeOut__vVRRO`,
	"modal": `ProjectSelectionModal_modal__8M3Xx`,
	"slideIn": `ProjectSelectionModal_slideIn__CzzeL`,
	"slideOut": `ProjectSelectionModal_slideOut__EV9Iq`,
	"header": `ProjectSelectionModal_header__WOrj0`,
	"closeButton": `ProjectSelectionModal_closeButton__nm1iY`,
	"backButton": `ProjectSelectionModal_backButton__tQeYZ`,
	"searchContainer": `ProjectSelectionModal_searchContainer__9SSiL`,
	"searchInput": `ProjectSelectionModal_searchInput__30qzb`,
	"content": `ProjectSelectionModal_content__rhOC0`,
	"projectItem": `ProjectSelectionModal_projectItem__whlDo`,
	"selected": `ProjectSelectionModal_selected__zovpN`,
	"projectInfo": `ProjectSelectionModal_projectInfo__1EDR1`,
	"projectName": `ProjectSelectionModal_projectName__W1mpg`,
	"clientName": `ProjectSelectionModal_clientName__Dgz+w`,
	"loading": `ProjectSelectionModal_loading__WfCSt`,
	"noResults": `ProjectSelectionModal_noResults__B7uzK`
};
export default ___CSS_LOADER_EXPORT___;
